import { useQuery } from '@tanstack/react-query';
import type { SortingState } from '@tanstack/react-table';

import {
  getTrackPerformance,
  type VintageFilter,
} from '~/modules/label-perf/api/label-perf';

interface TrackPerformanceQueryProps {
  majorLabels: string[];
  wmg1Labels?: number[];
  columnSort?: SortingState;
  pageNumber: number;
  limit?: number;
  vintage?: VintageFilter;
  mixOneEnrich?: boolean;
}

export function useTrackPerformanceQuery({
  majorLabels,
  wmg1Labels,
  columnSort,
  pageNumber,
  limit = 25,
  vintage,
  mixOneEnrich,
}: TrackPerformanceQueryProps) {
  const activeSort = columnSort?.[0];

  return useQuery({
    queryKey: [
      'track-performance',
      majorLabels,
      wmg1Labels,
      pageNumber,
      limit,
      vintage,
      activeSort?.id,
      activeSort?.desc,
    ],
    queryFn: () => {
      let order = '';

      if (activeSort) {
        const orderDirection = activeSort.desc ? '-' : '';

        switch (activeSort.id) {
          case 'streamsRtd':
            order = `${orderDirection}streams_rtd`;
            break;
          case 'streamsTw':
            order = `${orderDirection}streams_tw`;
            break;
          default:
            order = '';
        }
      }

      return getTrackPerformance(
        majorLabels,
        order,
        limit,
        (pageNumber - 1) * limit,
        wmg1Labels,
        vintage,
        mixOneEnrich,
      );
    },
  });
}
